import {
  Select,
  Input,
  message,
  Space,
  Button,
  DatePicker,
  Drawer,
} from "antd";
import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import Base from "../../Config/Base";
import { Footer } from "../footer/footer";
import { DeleteOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { API_BASE_CRM_URL } from "../../Config/Config";
import Swal from "sweetalert2";

const AddCredit = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [customerLoading, setCustomerLoading] = useState(false);
  const [productLoading, setProductLoading] = useState(false);
  const [userDetails, SetUserDetails] = useState([]);

  const [customers, setCustomers] = useState([]);
  const [products, setProducts] = useState([]);

  const [formData, setFormData] = useState({
    clientid: null,

    number: "",
    prefix: "CN",
    number_format: 1,

    date: dayjs(),
    duedate: dayjs().add(30, "day"),

    status: 1,
    currency: 1,
    sale_agent: null,

    project_id: 0,
    adjustment: 0,

    discount_percent: 0,
    discount_total: 0,
    discount_type: "before_tax",

    reference_no: "",

    adminnote: "",
    clientnote: "",
    terms: "",

    billing_street: "",
    billing_city: "",
    billing_state: "",
    billing_zip: "",
    billing_country: 1,

    shipping_street: "",
    shipping_city: "",
    shipping_state: "",
    shipping_zip: "",
    shipping_country: 1,

    // Shipping Options
    include_shipping: 0,
    show_shipping_on_credit_note: 0,

    // Quantity Display
    show_quantity_as: 1,
  });

  const [billingDrawerOpen, setBillingDrawerOpen] = useState(false);
  const [billingTemp, setBillingTemp] = useState({});
  const [shippingTemp, setShippingTemp] = useState({});

  const [staffList, setStaffList] = useState([]);

  const [selectedItems, setSelectedItems] = useState([]);
  useEffect(() => {
    const userDetailsSession = JSON.parse(
      sessionStorage.getItem("userDetails"),
    );

    SetUserDetails(userDetailsSession);

    setFormData((prev) => ({
      ...prev,
      sale_agent: userDetailsSession?.staffid || null,
    }));
  }, []);

  const getStaffDropdown = async () => {
    try {
      const response = await fetch(`${API_BASE_CRM_URL}staff/GetStaffDropdown`);

      const data = await response.json();

      if (data.Status) {
        setStaffList(data.ResultData || []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getCustomers = async () => {
    try {
      const response = await fetch(`${API_BASE_CRM_URL}customers/GetCustomers`);

      const data = await response.json();

      setCustomers(data.ResultData || []);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCustomers();
    getProducts();
    getStaffDropdown();
  }, []);

  const getProducts = async () => {
    try {
      setProductLoading(true);

      const response = await fetch(`${API_BASE_CRM_URL}products/GetProducts`);

      const data = await response.json();

      setProducts(data.Data || []);
    } catch (error) {
      console.log(error);
    } finally {
      setProductLoading(false);
    }
  };

  const handleCustomerChange = async (customerId) => {
    try {
      setCustomerLoading(true);

      const response = await fetch(
        `${API_BASE_CRM_URL}customers/GetCustomerDetails?CusId=${customerId}`,
      );

      const data = await response.json();

      if (data.Status && data.ResultData?.length) {
        const customer = data.ResultData[0];

        setFormData((prev) => ({
          ...prev,
          clientid: customer.customerId,

          billing_street: customer.billing_street || customer.address || "",
          billing_city: customer.billing_city || customer.city || "",
          billing_state: customer.billing_state || customer.state || "",
          billing_zip: customer.billing_zip || customer.zip || "",
          billing_country: customer.country || 1,

          shipping_street: customer.shipping_street || customer.address || "",
          shipping_city: customer.shipping_city || customer.city || "",
          shipping_state: customer.shipping_state || customer.state || "",
          shipping_zip: customer.shipping_zip || customer.zip || "",
          shipping_country: customer.country || 1,
        }));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setCustomerLoading(false);
    }
  };

  const handleProductSelect = (productId) => {
    const product = products.find((p) => p.id === productId);

    if (!product) return;

    const alreadyExists = selectedItems.some(
      (item) => item.item_id === product.id,
    );

    if (alreadyExists) return;

    setSelectedItems((prev) => [
      ...prev,
      {
        item_id: product.id,
        description: product.description,
        long_description: product.long_description,
        qty: 1,
        rate: Number(product.rate),
        tax: Number(product.tax || 0),
        unit: product.unit,
      },
    ]);
  };

  const updateQty = (index, qty) => {
    const items = [...selectedItems];

    items[index].qty = qty <= 0 ? 1 : qty;

    setSelectedItems(items);
  };

  const removeItem = (index) => {
    const items = [...selectedItems];

    items.splice(index, 1);

    setSelectedItems(items);
  };

  const subtotal = selectedItems.reduce(
    (sum, item) => sum + item.qty * item.rate,
    0,
  );

  const totalTax = selectedItems.reduce(
    (sum, item) => sum + item.qty * item.rate * (item.tax / 100),
    0,
  );

  const total = subtotal + totalTax;

  const openBillingDrawer = () => {
    setBillingTemp({
      billing_street: formData.billing_street,
      billing_city: formData.billing_city,
      billing_state: formData.billing_state,
      billing_zip: formData.billing_zip,
    });

    setShippingTemp({
      shipping_street: formData.shipping_street,
      shipping_city: formData.shipping_city,
      shipping_state: formData.shipping_state,
      shipping_zip: formData.shipping_zip,
    });

    setBillingDrawerOpen(true);
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const payload = {
        clientid: formData.clientid,

        number: Number(formData.number),
        prefix: formData.prefix,
        number_format: 1,

        date: formData.date.format("YYYY-MM-DD"),
        duedate: formData.duedate.format("YYYY-MM-DD"),

        currency: formData.currency || 1,

        subtotal,
        total_tax: totalTax,
        total,

        adjustment: formData.adjustment || 0,

        addedfrom: userDetails.staffid,

        status: formData.status,

        sale_agent: formData.sale_agent,

        discount_percent: formData.discount_percent || 0,
        discount_total: formData.discount_total || 0,
        discount_type: formData.discount_type || "before_tax",

        adminnote: formData.adminnote || "",
        clientnote: formData.clientnote || "",
        terms: formData.terms || "",

        reference_no: formData.reference_no || "",
        project_id: formData.project_id || 0,

        billing_street: formData.billing_street,
        billing_city: formData.billing_city,
        billing_state: formData.billing_state,
        billing_zip: formData.billing_zip,
        billing_country: formData.billing_country,

        shipping_street: formData.shipping_street,
        shipping_city: formData.shipping_city,
        shipping_state: formData.shipping_state,
        shipping_zip: formData.shipping_zip,
        shipping_country: formData.shipping_country,

        include_shipping: formData.include_shipping,
        show_shipping_on_credit_note: formData.show_shipping_on_credit_note,

        show_quantity_as: formData.show_quantity_as || 1,

        items: selectedItems.map((item) => ({
          item_id: item.item_id,
          description: item.description,
          long_description: item.long_description,
          qty: item.qty,
          rate: item.rate,
          unit: item.unit,
        })),
      };

      const response = await fetch(
        `${API_BASE_CRM_URL}creditnotes/AddCreditNotes`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const data = await response.json();

      if (data.Status) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 1000,
          showConfirmButton: false,
        });

        navigate("/credits");
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.Message,
        });
      }
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Base>
      <div className="row align-items-center mb-2">
        <div className="col-4">
          <div className="page-titl  d-flex">
            <h4>Add Credit</h4>
          </div>
        </div>
        <div className="col-6 d-flex justify-content-start">
          <Input
            addonBefore={<span className="fw-bold text-primary">CN-</span>}
            placeholder="Invoice Number"
            value={formData.number}
            onChange={(e) =>
              setFormData({
                ...formData,
                number: e.target.value,
              })
            }
          />
        </div>
        <div className="col-2 d-flex justify-content-end">
          <Link to="/credits">
            <button className="btn btn-sm btn-secondary">
              <i className="fa-solid fa-list"></i>
            </button>
          </Link>
        </div>
      </div>
      <div className="card shadow-sm border-0 mb-3">
        <div className="card-body">
          <div className="row g-2">
            <div className="col-12 d-flex">
              <Select
                showSearch
                className="w-100"
                placeholder="Select Customer"
                onChange={handleCustomerChange}
                options={customers?.map((customer) => ({
                  value: customer.customerId,
                  label: customer.company,
                }))}
              />
              <Button
                type="text"
                icon={<i className="fa-solid fa-location-dot"></i>}
                onClick={openBillingDrawer}
              />
            </div>

            <div className="col-6">
              <label className="form-label fw-medium mb-1">Date</label>
              <DatePicker
                className="w-100"
                format="DD-MM-YYYY"
                value={formData.date}
                onChange={(value) =>
                  setFormData({
                    ...formData,
                    date: value,
                  })
                }
              />
            </div>
            <div className="col-6">
              <label className="form-label fw-medium mb-1">Due</label>
              <DatePicker
                className="w-100"
                value={formData.duedate}
                disabledDate={(current) =>
                  current && current.isBefore(formData.date.startOf("day"))
                }
              />
            </div>
            <div className="col-6 d-none">
              <Select
                className="w-100"
                placeholder="Select Sale Agent"
                value={formData.sale_agent}
                onChange={(value) =>
                  setFormData((prev) => ({
                    ...prev,
                    sale_agent: value,
                  }))
                }
                options={staffList.map((staff) => ({
                  value: staff.staffid,
                  label: `${staff.firstname} ${staff.lastname}`,
                }))}
                // suffixIcon={<i className="fas fa-user-tie"></i>}
              />
            </div>
          </div>
        </div>
      </div>

      {/* <div className="card shadow-sm border-0 mb-2">
          <div className="card-header bg-white d-flex justify-content-between align-items-center py-1">
            <strong>
              <i className="fas fa-map-marker-alt text-success me-2"></i>
              Billing Address
            </strong>
  
            <Button
              type="text"
              icon={<i className="fas fa-edit text-primary"></i>}
              onClick={openBillingDrawer}
            />
          </div>
  
          <div className="card-body">
            <div className="row">
              <div className="col-6 mb-2">
                <i className="fas fa-road me-2 text-secondary"></i>
                {formData.billing_street || "-"}
              </div>
  
              <div className="col-6 mb-2">
                <i className="fas fa-city me-2 text-secondary"></i>
                {formData.billing_city || "-"}
              </div>
  
              <div className="col-6 mb-2">
                <i className="fas fa-map me-2 text-secondary"></i>
                {formData.billing_state || "-"}
              </div>
  
              <div className="col-6 mb-2">
                <i className="fas fa-mail-bulk me-2 text-secondary"></i>
                {formData.billing_zip || "-"}
              </div>
            </div>
          </div>
        </div> */}

      <div className="card shadow-sm border-0 mb-3">
        <div className="card-body">
          <strong className="mb-1">
            <i className="fas fa-box me-2 text-warning"></i>
            Products
          </strong>
          <Select
            showSearch
            size="large"
            className="w-100"
            placeholder="Select Product"
            onChange={handleProductSelect}
            options={products.map((product) => ({
              value: product.id,
              label: product.description,
            }))}
          />
        </div>
      </div>

      {selectedItems.map((item, index) => {
        const amount = item.qty * item.rate;
        const taxAmount = amount * (item.tax / 100);

        return (
          <div key={item.item_id} className="card border-0 shadow-sm mb-3">
            <div className="card-body">
              {/* Header */}

              <div className="d-flex justify-content-between align-items-start mb-1">
                <div>
                  <h5 className="mb-1 fw-semibold">{item.description}</h5>
                </div>

                <Button
                  danger
                  type="text"
                  icon={<DeleteOutlined />}
                  onClick={() => removeItem(index)}
                />
              </div>

              {/* Qty */}

              <div className="d-flex justify-content-between align-items-center mb-2">
                {/* Qty */}
                <div className="d-flex align-items-center">
                  <div className=" text-muted mb-1">Qty</div>

                  <div className="input-group" style={{ width: "105px" }}>
                    <button
                      className="btn btn-light border px-2"
                      type="button"
                      style={{ width: "30px" }}
                      onClick={() =>
                        updateQty(index, Math.max(1, item.qty - 1))
                      }
                    >
                      <i
                        className="fas fa-minus"
                        style={{ fontSize: "11px" }}
                      ></i>
                    </button>

                    <input
                      className="form-control text-center px-0"
                      style={{ maxWidth: "45px" }}
                      value={item.qty}
                      readOnly
                    />

                    <button
                      className="btn btn-light border px-2"
                      type="button"
                      style={{ width: "30px" }}
                      onClick={() => updateQty(index, item.qty + 1)}
                    >
                      <i
                        className="fas fa-plus"
                        style={{ fontSize: "11px" }}
                      ></i>
                    </button>
                  </div>
                </div>

                {/* Rate */}
                <div className="text-end d-flex">
                  <div className="small text-muted me-2">Rate</div>
                  <div className="fw-semibold">₹ {item.rate}</div>
                </div>
              </div>

              <hr className="m-1" />

              {/* Summary */}

              {/* <div className="d-flex justify-content-between mb-2">
                  <span className="text-muted">Tax</span>
  
                  <span className="fw-medium">{item.tax}%</span>
                </div>
  
                <div className="d-flex justify-content-between mb-2">
                  <span className="text-muted">Subtotal</span>
  
                  <span className="fw-medium">₹ {amount.toFixed(2)}</span>
                </div> */}

              <div className="d-flex justify-content-between">
                <span className="fw-semibold">Total</span>

                <span className="fw-bold text-success">
                  ₹ {(amount + taxAmount).toFixed(2)}
                </span>
              </div>
            </div>
          </div>
        );
      })}

      <div className="card border-0 shadow-sm">
        <div className="card-body">
          <div className="d-flex justify-content-between mb-2">
            <span>Subtotal</span>
            <strong>₹ {subtotal.toFixed(2)}</strong>
          </div>

          <div className="d-flex justify-content-between mb-2">
            <span>Tax</span>
            <strong>₹ {totalTax.toFixed(2)}</strong>
          </div>

          <hr />

          <div className="d-flex justify-content-between">
            <h5>Total</h5>
            <h5 className="text-success">₹ {total.toFixed(2)}</h5>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-end">
        <button
          className="btn btn-secondary btn-sm mt-3"
          onClick={handleSubmit}
          type="button"
          disabled={loading}
        >
          {loading ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
              />
              Saving...
            </>
          ) : (
            <>
              <i className="fas fa-save me-2"></i>
              Save
            </>
          )}
        </button>
      </div>

      <Drawer
        title={
          <>
            <i className="fas fa-map-marker-alt text-success me-2"></i>
            Edit Billing Address
          </>
        }
        placement="bottom"
        height="45%"
        open={billingDrawerOpen}
        onClose={() => setBillingDrawerOpen(false)}
        closeIcon={false}
        extra={
          <Space>
            <Button
              icon={<CloseOutlined />}
              onClick={() => setBillingDrawerOpen(false)}
            />

            <Button
              type="primary"
              icon={<CheckOutlined />}
              onClick={() => {
                setFormData((prev) => ({
                  ...prev,
                  ...billingTemp,
                }));

                setBillingDrawerOpen(false);
              }}
            />
          </Space>
        }
      >
        <div className="row">
          <div className="col-6">
            <Input
              size="large"
              className="mb-3"
              placeholder="Street"
              prefix={<i className="fas fa-road text-muted" />}
              value={billingTemp.billing_street}
              onChange={(e) =>
                setBillingTemp({
                  ...billingTemp,
                  billing_street: e.target.value,
                })
              }
            />
          </div>
          <div className="col-6">
            <Input
              size="large"
              className="mb-3"
              placeholder="City"
              prefix={<i className="fas fa-city text-muted" />}
              value={billingTemp.billing_city}
              onChange={(e) =>
                setBillingTemp({
                  ...billingTemp,
                  billing_city: e.target.value,
                })
              }
            />
          </div>
          <div className="col-6">
            <Input
              size="large"
              className="mb-3"
              placeholder="State"
              prefix={<i className="fas fa-map-marked-alt text-muted" />}
              value={billingTemp.billing_state}
              onChange={(e) =>
                setBillingTemp({
                  ...billingTemp,
                  billing_state: e.target.value,
                })
              }
            />
          </div>

          <div className="col-6">
            <Input
              size="large"
              className="mb-3"
              placeholder="Zip Code"
              prefix={<i className="fas fa-mail-bulk text-muted" />}
              value={billingTemp.billing_zip}
              onChange={(e) =>
                setBillingTemp({
                  ...billingTemp,
                  billing_zip: e.target.value,
                })
              }
            />
          </div>
        </div>

        <hr />
        <h4 className="mb-4">
          {" "}
          <i className="fas fa-map-marker-alt text-success me-2"></i> Edit
          Shipping Address
        </h4>
        <div className="row">
          <div className="col-6">
            <Input
              size="large"
              className="mb-3"
              placeholder="Street"
              prefix={<i className="fas fa-road text-muted" />}
              value={shippingTemp.shipping_street}
              onChange={(e) =>
                setShippingTemp({
                  ...shippingTemp,
                  shipping_street: e.target.value,
                })
              }
            />
          </div>

          <div className="col-6">
            <Input
              size="large"
              className="mb-3"
              placeholder="City"
              prefix={<i className="fas fa-city text-muted" />}
              value={shippingTemp.shipping_city}
              onChange={(e) =>
                setShippingTemp({
                  ...shippingTemp,
                  shipping_city: e.target.value,
                })
              }
            />
          </div>

          <div className="col-6">
            <Input
              size="large"
              className="mb-3"
              placeholder="State"
              prefix={<i className="fas fa-map-marked-alt text-muted" />}
              value={shippingTemp.shipping_state}
              onChange={(e) =>
                setShippingTemp({
                  ...shippingTemp,
                  shipping_state: e.target.value,
                })
              }
            />
          </div>

          <div className="col-6">
            <Input
              size="large"
              className="mb-3"
              placeholder="Zip Code"
              prefix={<i className="fas fa-mail-bulk text-muted" />}
              value={shippingTemp.shipping_zip}
              onChange={(e) =>
                setShippingTemp({
                  ...shippingTemp,
                  shipping_zip: e.target.value,
                })
              }
            />
          </div>
        </div>
      </Drawer>

      <Footer />
    </Base>
  );
};

export default AddCredit;
